import React, {useState, useEffect, Component, useRef} from 'react';
import {View, Text, BackHandler, ToastAndroid} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours, fontSize, spacing} from '../styles/Style';
import {
  GetGlobalTheme,
  IsHRWeb,
  DataTypes,
  WindowTypes,
  GetParameterID,
  GetDefaultBackBehaviour,
  WindowWrap,
  DisplayBrowseOKFlag,
  IsHRiOS,
  goBack,
  DoNavigate,
  ScreenHeight,
  ScreenWidth,
  UsePagination,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {YesNoWindow} from '../components/status/YesNoWindow';
import EditField from '../components/edit_elements/EditField';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import {b64toBlob} from '../Tools/Base64Decode';
import {translate} from '../Tools/LanguageTools';
import {Modal} from 'react-native';
import {SetCurrentWindow2, AddDateFilter} from '../Tools/WindowTools';
import KeyEvent from 'react-native-keyevent';
import {createDrawerNavigator} from '@react-navigation/drawer';

const kDefPerPage = 20;
const Drawer = createDrawerNavigator();

function headerfields(table) {
  let res = [
    {
      group: {
        fields: [
          {
            title: translate('SerNr'),
            dataKey: 'SerNr',
            viewOnly: true,
            width: '100px',
          },
          {
            title: translate('Location'),
            dataKey: 'Location',
            viewOnly: true,
            width: '150px',
          },
          {
            title: translate('Date'),
            dataKey: 'TransDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.handleInputChange,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Qty'),
            dataKey: 'HeaderQty',
            viewOnly: false,
            width: '150px',
            onChange: table.SetCurrentQty,
            type: DataTypes.kInputTypeQty,
          },
          {
            title: translate('Item'),
            dataKey: 'HeaderArtCode',
            viewOnly: false,
            width: '200px',
            reference: table.ArtCodeRef,
            onChange: table.SetCurrentItem,
            type: DataTypes.kInputTypeBarCode,
          },
        ],
      },
    },
  ];

  if (IsHRWeb()) {
    res[0].group.fields.splice(3, 0, {
      title: translate('Approved'),
      title2: translate('Approve'),
      dataKey: 'OKFlag',
      viewOnly: false,
      type: DataTypes.kInputTypeCheckbox,
      onChange: table.handleInputChange,
    });
  } else {
    res[0].group.fields.splice(0, 0, {
      title: translate('Approved'),
      title2: translate('Approve'),
      dataKey: 'OKFlag',
      viewOnly: false,
      type: DataTypes.kInputTypeCheckbox,
      onChange: table.handleInputChange,
    });
  }

  return res;
}

const TimeTableColumns = (table) => {
  let res = [];

  if (IsHRWeb()) {
    res.push({
      title: translate('Item'),
      dataKey: 'ArtCode',
      width: '100px',
      viewOnly: true,
    });
    res.push({
      title: translate('Name'),
      dataKey: 'Spec',
      width: '100px',
      viewOnly: true,
    });
    res.push({
      title: translate('InStock'),
      dataKey: 'Qty',
      width: '100px',
      viewOnly: true,
    });
  } else {
    res.push({
      title: translate('Item'),
      dataKey: 'ArtCode',
      dataKey2: 'Spec',
      width: '70%',
      viewOnly: true,
      type: DataTypes.kInputTypeJointField,
      overwrite: table.ItemColumn,
    });
    res.push({
      title: translate('InStock'),
      dataKey: 'Qty',
      width: '30%',
      cellstyle: {textAlign: 'right', justifyContent: 'flex-end'},
      style: {textAlign: 'right'},
      overwrite: table.QtyColumn,
      viewOnly: true,
    });
  }
  return res;
};

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 240px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
    flex-direction: column;
    align-items: center;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    margin-right: -30px;
  `}
`;
const FilterField = styled.View`
  ${IsHRWeb() &&
  css`
    margin-right: 30px;
  `}
`;
const FilterActions = styled.View`
  display: flex;
  ${(IsHRWeb() &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-end;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

const MatrixDivider = styled.View`
  ${(IsHRWeb() &&
    css`
      width: calc(100% - ${spacing.medium * 2}px - 12px);
    `) ||
  css`
    width: 100%;
  `}
  height: 1px;
  border-bottom-color: ${colours[GetGlobalTheme()].normalHighligh};
  border-bottom-width: 1;
  margin-horizontal: ${spacing.medium250};
  border-radius: 6px;
`;

class StockTakingsList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.createNewTable = this.createNewTable.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);
    this._isMounted = true;
    this.table = 'StockTakeVc';
    this.ArtCodeUpdatef = false;
    this.ScreenName = 'StockTakings';
    this.init = true;
    this.state = {
      data: [],
      record: {},
      px: 0,
      py: 0,
      show: false,
      WindowType: WindowTypes.Browse,
      newTableHelper: false,
      Location: '',
      CurrentItem: '',
      CurrentQty: '1',
      update: false,
    };
    this.navigation = props.navigation;
    SetCurrentWindow2('Stocktakings', 'SerNr', 'descending');
    AddDateFilter('Stocktakings');
  }
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(this.table, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };
  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.state.newTableHelper = false;
    this.getBrowseListData();
  };
  rowClick = (id) => {
    DoNavigate(this, 'StockTakings', true, id);
  };
  createNewTable = () => {
    if (this.state.Location == '') {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }
    let self = this;
    let tdata = {
      record: {
        Location: this.state.Location,
      },
    };
    Requests.getNewRecord(this.table, tdata)
      .then((response) => {
        if (response.success == true) {
          self.ShowHideNewTable();
          if (UsePagination() == false) {
            self.getBrowseListData();
          }
          self.rowClick(response.record.SerNr);
        }
      })
      .catch((error) => {});
  };
  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('Stocktakings', 'SerNr', 'descending');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  ShowHideNewTable = () => {
    if (this.state.newTableHelper) {
      global.PopEscapeActions();
      this.setState({newTableHelper: false});
    } else {
      this.setState({newTableHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewTable());
    }
  };
  renderNewButton = () => {
    let self = this;
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    return (
      <View
        key={'stocktaking_new'}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        <ActionButton
          onPress={() => this.ShowHideNewTable()}
          title={translate('AddNew')}
        />
        {this.state.newTableHelper && (
          <FilterView style={style2}>
            <FilterViewInner>
              <FilterFields>
                <FilterField>
                  <EditField
                    title={translate('Location') + '*'}
                    name={'Location'}
                    value={this.state.Location}
                    ps={'LocationVc'}
                    style={{width: 215}}
                    psheader={[
                      {
                        name: translate('Code'),
                        width: '35%',
                        key: 'Code',
                        mainkey: 'Code',
                      },
                      {
                        width: '65%',
                        name: translate('Name'),
                        key: 'Name',
                      },
                    ]}
                    onChange={(index, fn, value) =>
                      self.setState({Location: value})
                    }
                  />
                </FilterField>
              </FilterFields>
              <FilterActions>
                <ActionButton
                  style={IsHRWeb() ? {marginTop: 20, marginRight: 20} : {}}
                  onPress={() => this.ShowHideNewTable()}
                  title={translate('Cancel')}
                />
                <ActionButton
                  style={IsHRWeb() ? {marginTop: 20} : {}}
                  onPress={() => this.createNewTable()}
                  title={translate('Create')}
                />
              </FilterActions>
            </FilterViewInner>
          </FilterView>
        )}
      </View>
    );
  };
  render() {
    let self = this;
    KeyEvent.removeKeyDownListener();
    return (
      <WindowWrap>
        <TableContainer
          table={this.table}
          update={this.state.update}
          data={this.state.data}
          columns={[
            {
              title: translate('SerNr'),
              dataKey: 'sernr',
              sortKey: 'SerNr',
              width: '150px',
            },
            {
              title: translate('Location'),
              dataKey: 'location',
              sortKey: 'Location',
              width: '150px',
            },
            {
              title: translate('Date'),
              dataKey: 'transdate',
              sortKey: 'TransDate',
              width: '170px',
              type: DataTypes.kInputTypeDate,
            },
            {
              title: translate('Approved'),
              dataKey: 'okflag',
              sortKey: 'OKFlag',
              width: '100px',
              overwrite: DisplayBrowseOKFlag,
            },
          ]}
          doClick={self.rowClick}
          rowID={'sernr'}
          title={translate(this.ScreenName)}
          width="800px"
          extraContent={this.renderNewButton}
        />
      </WindowWrap>
    );
  }
}

class StockTakingsRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.SetCurrentItem = this.SetCurrentItem.bind(this);
    this.SetCurrentQty = this.SetCurrentQty.bind(this);

    //this.changePage = this.changePage.bind(this);
    this._isMounted = true;
    this.table = 'StockTakeVc';
    this.ArtCodeRef = React.createRef();
    this.ArtCodeUpdatef = false;
    this.ScreenName = 'StockTakings';
    this.state = {
      data: [],
      record: {},
      show: false,
      WindowType: WindowTypes.Browse,
      newTableHelper: false,
      Location: '',
      CurrentItem: '',
      CurrentQty: '1',
      pagination: {
        page: 0,
        perpage: kDefPerPage,
        pages: 0,
        change: function (page) {
          self.changePage(page);
        },
        changePagePeriod: function (value) {
          self.changePagePeriod(value);
        },
      },
    };
    this.navigation = props.navigation;
    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }
  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.setState({record: {}});
    Requests.getTableData(this.table, {SerNr: id}, undefined, undefined, true)
      .then((response) => {
        self.state.id = response.records[0].SerNr;
        if (!response.records[0].rows) {
          response.records[0].rows = [];
        }
        self.setMatrixPagination(response.records[0].rows.length);
        response.records[0].HeaderQty = self.state.CurrentQty;
        self.setState({record: response.records[0]});
      })
      .catch((error) => {});
  };

  handleInputChange = (rowindex, index, value) => {
    let self = this;
    Requests.updateRecordData(this.table, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.SerNr,
    })
      .then((response) => {
        if (response.success) {
          if (self._isMounted) {
            self.state.record = {};
            self.setState({record: response.record});
          }
        } else {
          if (self._isMounted) {
            ResetRecord(self, index, rowindex, value);
          }
        }
      })
      .catch((error) => {});
  };
  GetItemInsertData = (item, qty) => {
    let res = {
      list: [
        {
          rownr: this.state.record.rows.length,
          field: 'ArtCode',
          value: item,
        },
        {
          rownr: this.state.record.rows.length,
          field: 'Qty',
          value: qty,
        },
      ],
      id: this.state.record.SerNr,
    };

    for (let i = 0; i < this.state.record.rows.length; i++) {
      let row = this.state.record.rows[i];
      let index = i;
      if (row.ArtCode !== undefined) {
        if (row.ArtCode.toUpperCase() == item.toUpperCase()) {
          res = {
            rownr: index,
            field: 'Qty',
            value: (parseInt(row.Qty) || 0) + parseInt(qty),
            id: this.state.record.SerNr,
          };
          break;
        }
      }
    }

    return res;
  };
  ItemColumn = (value, rowindex, columnindex, value2 = '') => {
    return (
      <>
        <Text style={{color: colours[GetGlobalTheme()].inputText}}>
          {value}
        </Text>
        {value2 != '' && (
          <Text style={{color: colours[GetGlobalTheme()].inputText}}>
            {value2}
          </Text>
        )}
      </>
    );
  };
  QtyColumn = (value, rowindex, columnindex) => {
    return (
      <Text style={{color: colours[GetGlobalTheme()].inputText}}>{value}</Text>
    );
  };

  SetCurrentItem = (rowindex, index, value) => {
    if (value !== '' && value !== null && value !== undefined) {
      let self = this;
      this.state.CurrentItem = value;
      let data = this.GetItemInsertData(
        this.state.CurrentItem,
        this.state.CurrentQty
      );
      let trec = Object.assign({}, this.state.record);
      trec.rows = this.state.record.rows.slice();
      let nrec = this.state.record;
      if (data.hasOwnProperty('rownr')) {
        nrec.rows[data.rownr][data.field] = data.value;
      } else {
        nrec.rows[data.list[0].rownr] = {};
        nrec.rows[data.list[0].rownr][data.list[0].field] = data.list[0].value;
        nrec.rows[data.list[1].rownr][data.list[1].field] = data.list[1].value;
      }
      this.state.CurrentQty = '1';
      this.state.CurrentItem = '';
      nrec.HeaderArtCode = ' ';
      nrec.HeaderQty = ' ';

      this.setState({record: nrec}, function () {
        nrec.HeaderArtCode = '';
        nrec.HeaderQty = '1';
        self.ArtCodeUpdatef = true;
        self.setState({record: nrec}, function () {
          self.ArtCodeRef.current.focus();
        });
      });

      Requests.updateRecordData(this.table, data)
        .then((response) => {
          if (response.success) {
            if (self._isMounted) {
              self.state.record = {};
              response.record.HeaderArtCode = '';
              response.record.HeaderQty = '1';
              self.setState({record: response.record}, function () {
                self.ArtCodeRef.current.focus();
              });
              if (IsHRWeb() == false) {
                ToastAndroid.show(
                  translate('ItemAdded').replace('{Item}', value),
                  ToastAndroid.SHORT
                );
              }
            }
          } else {
            self.state.record = {};
            trec.HeaderArtCode = ' ';
            trec.HeaderQty = ' ';

            self.setState({record: trec}, function () {
              trec.HeaderArtCode = '';
              trec.HeaderQty = '1';
              self.setState({record: trec});
            });
          }
        })
        .catch((error) => {
          self.state.record = {};
          trec.HeaderArtCode = ' ';
          trec.HeaderQty = ' ';

          self.setState({record: trec}, function () {
            trec.HeaderArtCode = '';
            trec.HeaderQty = '1';
            self.setState({record: trec});
          });
        });
    }
  };

  SetCurrentQty = (rowindex, index, value) => {
    let nrec = this.state.record;
    nrec.HeaderQty = value.toString();
    this.state.CurrentQty = value.toString();
    this.setState({record: nrec});
  };

  componentDidUpdate(props) {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }

  changePage = (page) => {
    let npagination = this.state.pagination;
    npagination.page = page;
    this.setState({pagination: npagination});
  };
  changePagePeriod = (value) => {
    let npagination = this.state.pagination;
    npagination.perpage = value;
    npagination.page = 0;
    this.setMatrixPagination(this.state.record.rows.length);
    this.setState({pagination: npagination});
  };
  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(this.table, this.state.record.SerNr)
      .then((response) => {
        if (response.success === true) {
          self.state.ActiveID = '';
          DoNavigate(self, 'StockTakings', false, '', true, true);
        }
      })
      .catch((error) => {});
  };

  downloadDocument = () => {
    /*application/octet-stream*/
    let self = this;
    //window.open('about:blank', 'Downloading');
    Requests.downloadDocument(5, {id: this.state.record.SerNr})
      .then((response) => {
        if (response.file !== '') {
          let blob = b64toBlob(response.file, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          // the filename you want
          //a.download = response.name;
          //  a.target = '_blank';
          document.body.appendChild(a);
          window.open(url, 'Downloading');
          //window.URL.revokeObjectURL(url);
        } else {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('DocumentNotFound'),
          });
        }
      })
      .catch((error) => {});
  };

  render() {
    let self = this;
    KeyEvent.removeKeyDownListener();
    return (
      <WindowWrap>
        <InspectWindow
          title={translate('StockTaking')}
          window={this}
          headerfields={headerfields(this)}
          record={this.state.record}
          columns={TimeTableColumns(this)}
          pagination={this.state.pagination}
          okcheck={'OKFlag'}
          allowDelete={true}
          allowPrint={false}
          width="800px"
          backButton={() => goBack(self, self.ScreenName)}
        />

        {this.state.activeDelete && (
          <Modal transparent={true}>
            <YesNoWindow
              question={translate('RemoveQuestion')}
              yes={() => this.deleteRecord()}
              no={() => this.setState({activeDelete: false})}
            />
          </Modal>
        )}
      </WindowWrap>
    );
  }
}

function StockTakings() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="StockTakingsList"
        component={StockTakingsList}
        options={{
          title: translate('StockTakings'),
        }}
      />
      <Drawer.Screen
        name="StockTakingsRecord"
        component={StockTakingsRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('StockTaking'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default StockTakings;
